import Vue from 'vue'

// Public: Mounts a component in the specified $vm as the parent.
//
// Returns a mounted component instance.
export function mountComponent ($vm, componentConfig, options = {}) {
  const Component = Vue.extend(componentConfig)
  return new Component({ parent: $vm, ...options }).$mount()
}
